import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

const PoliticaRimborsi = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1>Politica rimborsi e cancellazioni</h1>
          <p>Ultimo aggiornamento: 29 giugno 2026</p>
        </div>

        <section>
          <h2>Prima dell'attivazione</h2>
          <p>
            Se il servizio non è ancora iniziato e non è stata confermata alcuna programmazione, la famiglia può
            richiedere l'annullamento dell'iscrizione e il rimborso del pagamento effettuato.
          </p>
        </section>

        <section>
          <h2>Dopo l'avvio del servizio</h2>
          <p>
            Dopo l'avvio del percorso, eventuali rimborsi vengono valutati in base alle attività già organizzate o
            svolte, al piano acquistato e agli accordi presi con la famiglia.
          </p>
        </section>

        <section>
          <h2>Pacchetti personalizzati</h2>
          <p>
            I pacchetti personalizzati vengono definiti solo dopo una call conoscitiva. Obiettivi, durata, frequenza,
            prezzo e condizioni di cancellazione sono comunicati prima del pagamento.
          </p>
        </section>

        <section>
          <h2>Come richiedere assistenza</h2>
          <p>
            Per cancellazioni, dubbi o richieste di rimborso è possibile contattarci tramite la pagina contatti indicando
            nome del genitore, email usata per l'iscrizione e piano acquistato.
          </p>
        </section>

        <div className="legal-actions">
          <Button asChild className="btn-primary">
            <Link to="/contatti">Richiedi assistenza</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/">Torna alla home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PoliticaRimborsi;
